export default __webpack_public_path__ + "static/media/Tackling_Dreaded_DotNet_Cold_Starts_When_Going_Serverless_NDC_Sydney.4e26d356.png";